module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "event relative pointer m-2",
    on: {
      "click": _vm.showDetails,
      "mouseenter": _vm.showBook,
      "mouseleave": _vm.hideBook
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.button) ? _c('button', {
    staticClass: "btn book lines",
    on: {
      "click": function($event) {
        return _vm.book($event, _vm.event)
      }
    }
  }, [_vm._v("BOOK")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "information bg-lightest darker border-light py-2 px-3"
  }, [_c('div', {
    staticClass: "d-inline-block bold"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("moment")(_vm.event.start, 'HH:mm')) + " to " + _vm._s(_vm._f("moment")(_vm.event.end, 'HH:mm')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), (_vm.product.transport) ? _c('p', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.product.transport.name))]) : _vm._e()]), _vm._v(" "), _c('event-meter', {
    attrs: {
      "event": _vm.event,
      "showText": true
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7f1ca442", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1ca442"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Event.vue
// module id = 1657
// module chunks = 0